import { enumToSelectItemsWithHumanizedLabelAsKeyValue } from "web_modules/shared/FormHelpers/carbon-helpers";

// Relationships for sign up flow
export enum AANOptions {
  CREDIT_APPLICATION_INCOMPLETE = "CREDIT_APPLICATION_INCOMPLETE",
  INSUFFICIENT_NUMBER_OF_CREDIT_REFERENCES_PROVIDED = "INSUFFICIENT_NUMBER_OF_CREDIT_REFERENCES_PROVIDED",
  UNACCEPTABLE_TYPE_OF_CREDIT_REFERENCES_PROVIDED = "UNACCEPTABLE_TYPE_OF_CREDIT_REFERENCES_PROVIDED",
  UNABLE_TO_VERIFY_CREDIT_REFERENCES = "UNABLE_TO_VERIFY_CREDIT_REFERENCES",
  TEMPORARY_OR_IRREGULAR_EMPLOYMENT = "TEMPORARY_OR_IRREGULAR_EMPLOYMENT",
  UNABLE_TO_VERIFY_EMPLOYMENT = "UNABLE_TO_VERIFY_EMPLOYMENT",
  LENGTH_OF_EMPLOYMENT = "LENGTH_OF_EMPLOYMENT",
  INCOME_INSUFFICIENT_FOR_AMOUNT_OF_CREDIT_REQUESTED = "INCOME_INSUFFICIENT_FOR_AMOUNT_OF_CREDIT_REQUESTED",
  EXCESSIVE_OBLIGATIONS_IN_RELATION_TO_INCOME = "EXCESSIVE_OBLIGATIONS_IN_RELATION_TO_INCOME",
  UNABLE_TO_VERIFY_INCOME = "UNABLE_TO_VERIFY_INCOME",
  INSTABILITY_OF_INCOME = "INSTABILITY_OF_INCOME",
  INSUFFICIENT_LENGTH_OF_EMPLOYMENT = "INSUFFICIENT_LENGTH_OF_EMPLOYMENT",
  LENGTH_OF_RESIDENCE = "LENGTH_OF_RESIDENCE",
  TEMPORARY_RESIDENCE = "TEMPORARY_RESIDENCE",
  UNABLE_TO_VERIFY_RESIDENCE = "UNABLE_TO_VERIFY_RESIDENCE",
  NO_CREDIT_FILE = "NO_CREDIT_FILE",
  LIMITED_CREDIT_EXPERIENCE = "LIMITED_CREDIT_EXPERIENCE",
  POOR_CREDIT_PERFORMANCE_WITH_US = "POOR_CREDIT_PERFORMANCE_WITH_US",
  DELINQUENT_PAST_OR_PRESENT_CREDIT_OBLIGATIONS_WITH_OTHERS = "DELINQUENT_PAST_OR_PRESENT_CREDIT_OBLIGATIONS_WITH_OTHERS",
  COLLECTION_ACTION_OR_JUDGMENT = "COLLECTION_ACTION_OR_JUDGMENT",
  GARNISHMENT_OR_ATTACHMENT = "GARNISHMENT_OR_ATTACHMENT",
  FORECLOSURE_OR_REPOSSESSION = "FORECLOSURE_OR_REPOSSESSION",
  BANKRUPTCY = "BANKRUPTCY",
  NUMBER_OF_RECENT_INQUIRIES_ON_CREDIT_BUREAU_REPORT = "NUMBER_OF_RECENT_INQUIRIES_ON_CREDIT_BUREAU_REPORT",
  VALUE_OR_TYPE_OF_COLLATERAL_NOT_SUFFICIENT = "VALUE_OR_TYPE_OF_COLLATERAL_NOT_SUFFICIENT",
  INSUFFICIENT_ASSETS = "INSUFFICIENT_ASSETS",
  OTHER = "Other",
}

export const aansOptions = enumToSelectItemsWithHumanizedLabelAsKeyValue(AANOptions);
